import { rgba } from "polished";
import styled from "styled-components";
import Image from "../../../../../base/multimedia/image/index.js";
import { BoxShadow, BoxShadowHover } from "../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
export const BlogSingleContainer = styled.div.withConfig({
    displayName: "styled__BlogSingleContainer",
    componentId: "sc-89eeeade-0"
})`
	${BoxShadowHover}
	${BoxShadow}
	flex-grow: 1;
	flex-shrink: 0;
	height: auto;
	width: calc(50% - 12px);

	&.blog-item__container.blog-item__container--featured {
		flex-grow: 1;
		flex-shrink: 0;
		width: 100%;
	}

	&.blog-item__container {
		${BorderRadius({
    all: '4px'
})}
		background-color: ${({ theme  })=>theme.colors.white.base};
		position: relative;
		width: calc(50% - 12px);
	}
`;
export const BlogSingleMain = styled.div.withConfig({
    displayName: "styled__BlogSingleMain",
    componentId: "sc-89eeeade-1"
})`
	${BorderRadius({
    all: '4px'
})}
	${FlexMixin()}
	height: 100%;
	overflow: hidden;
	width: 100%;
`;
export const BlogSingleMainLink = styled.a.withConfig({
    displayName: "styled__BlogSingleMainLink",
    componentId: "sc-89eeeade-2"
})`
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
	position: relative;
	height: 340px;
	width: 50%;
`;
export const BlogSingleDate = styled.div.withConfig({
    displayName: "styled__BlogSingleDate",
    componentId: "sc-89eeeade-3"
})`
	${FlexMixin({
    direction: 'column'
})}
	left: 16px;
	position: absolute;
	text-transform: uppercase;
	top: 16px;
	z-index: 1;
`;
export const BlogSingleDay = styled.span.withConfig({
    displayName: "styled__BlogSingleDay",
    componentId: "sc-89eeeade-4"
})`
	${FontMixin({
    size: 'xl',
    height: 'largest',
    weight: 'light'
})}
	align-self: flex-start;
	background-color: ${({ theme  })=>rgba(theme.colors.primary.light ?? theme.colors.primary.base, 0.7)};
	color: ${({ theme  })=>theme.colors.white.base};
	letter-spacing: -1px;
	margin-bottom: 2px;
	min-width: 52px;
	padding: 8px 10px;
	text-align: center;
`;
export const BlogSingleMonthAndYear = styled.span.withConfig({
    displayName: "styled__BlogSingleMonthAndYear",
    componentId: "sc-89eeeade-5"
})`
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'regular'
})}
	background-color: ${({ theme  })=>rgba(theme.colors.primary.light ?? theme.colors.primary.base, 0.7)};
	color: ${({ theme  })=>theme.colors.white.base};
	padding: 6px 8px 4px;
`;
export const BlogSingleImage = styled(Image).withConfig({
    displayName: "styled__BlogSingleImage",
    componentId: "sc-89eeeade-6"
})`
	height: 340px;
	overflow: hidden;
	position: relative;
	position: relative;
	width: auto;

	img {
		height: 100%;
		left: 50%;
		object-fit: cover;
		position: absolute;
		top: 50%;
		transform: translateY(-50%) translateX(-50%);
	}
`;
export const BlogSingleContent = styled.div.withConfig({
    displayName: "styled__BlogSingleContent",
    componentId: "sc-89eeeade-7"
})`
	${FlexMixin({
    direction: 'column'
})}
	width: 100%;
	flex-grow: 1;
`;
export const BlogSingleContentLink = styled.a.withConfig({
    displayName: "styled__BlogSingleContentLink",
    componentId: "sc-89eeeade-8"
})`
	.blog-item__container.blog-item__container--featured & {
		text-decoration: none;
	}
`;
export const BlogSingleBlock = styled.div.withConfig({
    displayName: "styled__BlogSingleBlock",
    componentId: "sc-89eeeade-9"
})`
	padding: 12px 16px;

	.blog-item__container.blog-item__container--featured & {
		padding: 16px;
	}
`;
export const BlogSingleTitle = styled.h3.withConfig({
    displayName: "styled__BlogSingleTitle",
    componentId: "sc-89eeeade-10"
})`
	color: ${({ theme  })=>theme.colors.primary.base};
	${FontMixin({
    size: 'large',
    height: 'large',
    weight: 'regular'
})}
	margin: 0 0 8px;

	.blog-item__container.blog-item__container--featured & {
		${FontMixin({
    size: 'larger',
    height: 'large'
})}
	}
`;
export const BlogSingleDescription = styled.p.withConfig({
    displayName: "styled__BlogSingleDescription",
    componentId: "sc-89eeeade-11"
})`
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'light'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
	margin: 0;
`;
export const BlogSingleFooter = styled.div.withConfig({
    displayName: "styled__BlogSingleFooter",
    componentId: "sc-89eeeade-12"
})`
	${FlexMixin({
    justify: 'space-between',
    direction: 'row',
    align: 'center'
})}
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'light'
})}
	border-top: 1px solid ${({ theme  })=>theme.colors.grays.lighter};
	color: ${({ theme  })=>theme.colors.grays.dark};
	margin-top: auto;
	padding: 14px 16px;
`;
export const BlogSingleWrapper = styled.div.withConfig({
    displayName: "styled__BlogSingleWrapper",
    componentId: "sc-89eeeade-13"
})`
	${BlogSingleFooter} & {
		${FlexMixin({
    justify: 'space-between',
    align: 'center'
})}
		flex: 1;
	}

	${BlogSingleFooter} &:last-of-type {
		${FlexMixin({
    justify: 'flex-end'
})}
	}
`;
export const BlogSingleShareButtons = styled.div.withConfig({
    displayName: "styled__BlogSingleShareButtons",
    componentId: "sc-89eeeade-14"
})`
	${FlexMixin()}
	margin-right: auto;
`;
export const BlogSingleIconLink = styled.a.withConfig({
    displayName: "styled__BlogSingleIconLink",
    componentId: "sc-89eeeade-15"
})`
	${BorderRadius({
    all: '50%'
})}
	${FlexMixin({
    justify: 'center',
    align: 'center'
})}
	${FontMixin({
    size: 'small',
    height: 'large',
    weight: 'regular'
})}
	background-color: ${({ theme  })=>theme.colors.grays.base};
	color: ${({ theme  })=>theme.colors.white.base};
	height: 24px;
	margin-right: 8px;
	opacity: 0.7;
	text-align: center;
	transition: all 0.3s;
	width: 24px;
`;
export const BlogSingleViewMore = styled.div.withConfig({
    displayName: "styled__BlogSingleViewMore",
    componentId: "sc-89eeeade-16"
})`
	&:first-child:before {
		display: none;
	}

	${({ theme  })=>theme.media.up('lg')} {
		&:before {
			margin: 0 12px;
		}
	}

	${({ theme  })=>theme.media.up('xl')} {
		&:before {
			margin: 0 20px;
		}
	}

	&:before {
		border-left: 1px solid ${({ theme  })=>theme.colors.grays.lighter};
		content: '';
		font-size: 16px;
		margin: 0 20px;
		vertical-align: middle;
	}
`;
export const BlogSingleViewMoreLink = styled.a.withConfig({
    displayName: "styled__BlogSingleViewMoreLink",
    componentId: "sc-89eeeade-17"
})`
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'medium'
})}
	color: ${({ theme  })=>theme.colors.primary.light};
	cursor: pointer;
`;
export const BlogSingleTagLabel = styled.span.withConfig({
    displayName: "styled__BlogSingleTagLabel",
    componentId: "sc-89eeeade-18"
})`
	position: absolute;
	margin-bottom: 100px;
	${FontMixin({
    height: 'base',
    weight: 'regular'
})}
	padding-right: 12px;
`;

//# sourceMappingURL=styled.js.map